// import { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { FaChevronDown, FaChevronRight, FaCircle, FaTimes } from "react-icons/fa";
// import { menus } from "../../services/Menus.Service";

// const Sidebar = ({ isOpen, onClose }) => {
//   const location = useLocation();
//   const [expandedMenu, setExpandedMenu] = useState(null);

//   const toggleMenu = (menuName) => {
//     setExpandedMenu((prev) => (prev === menuName ? null : menuName));
//   };

//   const isSubmenuActive = (path) => location.pathname === path;
//   const isMainMenuActive = (menu) =>
//     menu.items.some((item) => isSubmenuActive(item.path));

//   return (
//     <div
//       className={`sidebar bg-light text-dark p-0 position-fixed top-0 start-0 h-100 
//       ${isOpen ? "d-block" : "d-none d-md-block"}`}
//       style={{ width: 250, zIndex: 9999, marginTop: "6vw" }}
//     >
//       {/* Close button for mobile */}
//       <div className="d-flex justify-content-between align-items-center p-2 d-md-none">
//         <h5 className="m-0">Menu</h5>
//         <FaTimes size={20} onClick={onClose} style={{ cursor: "pointer" }} />
//       </div>

//       <ul className="nav flex-column gap-2">
//         {menus.map((menu) => {
//           const mainActive = isMainMenuActive(menu);
//           const isExpanded = expandedMenu === menu.name;
//           return (
//             <li key={menu.name}>
//               <div
//                 className="d-flex justify-content-between align-items-center fw-bold px-2 py-1"
//                 style={{
//                   cursor: "pointer",
//                   backgroundColor: mainActive ? "#e6e7ea" : "transparent",
//                   borderRadius: "10px",
//                 }}
//                 onClick={() => toggleMenu(menu.name)}
//               >
//                 <span>
//                   <FaCircle
//                     size={12}
//                     style={{ color: mainActive ? "#666cff" : "black" }}
//                     className="me-2"
//                   />
//                   {menu.name}
//                 </span>
//                 {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
//               </div>
//               {isExpanded && (
//                 <ul className="nav flex-column mt-2 ">
//                   {menu.items.map((item) => (
//                     <li key={item.path}>
//                       <Link
//                         to={item.path}
//                         className={`nav-link px-2 py-1 ${
//                           isSubmenuActive(item.path)
//                             ? "text-white"
//                             : "text-dark"
//                         }`}
//                         style={{
//                           borderRadius: "10px",
//                           backgroundColor: isSubmenuActive(item.path)
//                             ? "#666cff"
//                             : "transparent",
//                         }}
//                         onClick={onClose}
//                       >
//                         <FaCircle className="me-2 mx-3" size={12} /> {item.name}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>
//           );
//         })}
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;


import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getAccessibleMenus } from "../../utils/menuAccess";
import {
  FaChevronDown,
  FaChevronRight,
  FaUsers,
  FaCity,
  FaTags,
  FaImages,
  FaFlag,
  FaClock,
  FaVials,
  FaBox,
  FaShoppingCart,
  FaBell,
  FaFileMedical,
  FaUserShield,
  FaUserMd,
  FaLayerGroup,
  FaTimes,
  FaCircle,
  FaTicketAlt,
  FaCreditCard,
} from "react-icons/fa";

const menuIcons = {
  Users: <FaUsers />,
  "Service Locations": <FaCity />,
  Categories: <FaTags />,
  Sliders: <FaImages />,
  Banners: <FaFlag />,
  Slots: <FaClock />,
  Tests: <FaVials />,
  Packages: <FaBox />,
  Coupons: <FaTicketAlt />,
  Grouping: <FaLayerGroup />,
  Orders: <FaShoppingCart />,
  "Payment Gateway": <FaCreditCard />,
  Notifications: <FaBell />,
  Prescriptions: <FaFileMedical />,
  Access: <FaUserShield />,
  "Lab Technicians": <FaUserMd />,
};

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const [expandedMenu, setExpandedMenu] = useState(null);
  const menus = getAccessibleMenus();

  const toggleMenu = (menuName) => {
    setExpandedMenu((prev) => (prev === menuName ? null : menuName));
  };

  const isSubmenuActive = (path) => location.pathname === path;
  const isMainMenuActive = (menu) =>
    menu.items.some((item) => isSubmenuActive(item.path));

  return (
    <div
      className={`sidebar bg-light text-dark p-0 position-fixed top-0 start-0 h-100 
      ${isOpen ? "d-block" : "d-none d-md-block"}`}
      style={{
        width: 250,
        zIndex: 9999,
        marginTop: "6vw",
        maxHeight: "calc(100vh - 6vw)",
        overflowY: "auto",
        overflowX: "hidden",
        boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
      }}
    >
      {/* Mobile Close Button */}
      <div className="d-flex justify-content-between align-items-center p-3 d-md-none border-bottom">
        <h5 className="m-0">Menu</h5>
        <FaTimes size={20} onClick={onClose} style={{ cursor: "pointer" }} />
      </div>

      <ul className="nav flex-column gap-1 p-2">
        {menus.map((menu) => {
          const mainActive = isMainMenuActive(menu);
          const isExpanded = expandedMenu === menu.name;

          // A menu with a single page is a direct link; only multi-page menus get a dropdown.
          if (menu.items.length === 1) {
            const [item] = menu.items;
            return (
              <li key={menu.name} className="mb-1">
                <Link
                  to={item.path}
                  className={`d-flex justify-content-between align-items-center fw-bold px-3 py-2 rounded text-decoration-none ${
                    mainActive ? "bg-primary text-white" : "text-dark"
                  }`}
                  onClick={onClose}
                >
                  <span className="d-flex align-items-center">
                    <span className="me-2">{menuIcons[menu.name]}</span>
                    {menu.name}
                  </span>
                  <FaChevronRight />
                </Link>
              </li>
            );
          }

          return (
            <li key={menu.name} className="mb-1">
              {/* Main Menu */}
              <div
                className={`d-flex justify-content-between align-items-center fw-bold px-3 py-2 rounded ${
                  mainActive ? "bg-primary text-white" : "text-dark"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => toggleMenu(menu.name)}
              >
                <span className="d-flex align-items-center">
                  <span className="me-2">{menuIcons[menu.name]}</span>
                  {menu.name}
                </span>
                {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
              </div>

              {/* Submenu */}
              {isExpanded && (
                <ul className="nav flex-column mt-1 ms-4">
                  {menu.items.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className={`nav-link px-2 py-1 rounded ${
                          isSubmenuActive(item.path)
                            ? "bg-primary text-white"
                            : "text-dark"
                        }`}
                        onClick={onClose}
                      >
                        <FaCircle className="me-2" size={8} /> {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;
